import React from 'react';
import { SocialIcon } from 'react-social-icons';

const SocialMedia = () => {
	return (
		<div className="social-media" role="group" aria-label="Social Media Links">
			<SocialIcon fgColor="#1E847C" bgColor="transparent" className="social-media-icon" url="https://www.facebook.com/sitlosaigon/" aria-label="Follow Sit Lo Saigon on Facebook" />
			<SocialIcon fgColor="#1E847C" bgColor="transparent" className="social-media-icon" url="https://www.yelp.com/biz/sit-lo-saigon-elk-grove" aria-label="Check out Sit Lo Saigon on Yelp" />
			<SocialIcon fgColor="#1E847C" bgColor="transparent" className="social-media-icon" url="https://www.instagram.com/sitlosaigon/" aria-label="Follow Sit Lo Saigon on Instagram" />
		</div>
	);
};

export default SocialMedia;